import React from 'react';
import { ModalContainer, ModalContent } from './index.style';

import { ModalClose, XIcon } from '../assets/icons';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  isFileUpload?: boolean;
  hasBg?: boolean;
}

const Modal: React.FC<IProps> = ({ isOpen, onClose, children, isFileUpload, hasBg = true }) => {
  return (
    <ModalContainer isOpen={isOpen} onClick={onClose}>
      <ModalContent isFileUpload={isFileUpload} onClick={(e) => e.stopPropagation()} hasBg={hasBg}>
        {children}
        <button className='close' type='button' onClick={onClose}><ModalClose /></button>
      </ModalContent>
    </ModalContainer>
  );
};

export default Modal;
